<template>
	<div class='tax-data-edit'>
		<span class='title'>Общие данные</span>
		<EditGeneral class='general-outer'/>
		<span class='title'>Ярусы</span>
		<EditLayers class='layers-outer'/>

		<!-- <div class='save-block'>
			lalala
		</div> -->
	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex';

	import EditGeneral from './TaxDataEditGeneral';
	import EditLayers from './TaxDataEditLayers';

	export default {
		name: 'TaxDataEdit',
		components: {
			EditGeneral,
			EditLayers
		},

		methods: {

		},

	};
</script>

<style scoped>
	.title {
		display: inline-block;
		font-size: 1.6rem;
		font-weight: bold;
		margin-bottom: 20px;
		margin-top: 20px;
	}

	.save-block {
		border: 1px solid black;
		height: 400px;
		background-color: lightblue;
		position: sticky;
		bottom: 0;
	}

	.general-outer {

		margin-bottom: 50px;
	}
</style>